/* Three Oh Six — Exit-Intent-Overlay
   Trigger: Desktop mouseleave am oberen Rand; Mobil schnelles Aufwärts-Scrollen
   nach >=50% Scroll-Tiefe. Frequency-Cap via localStorage.
   Seit 3.10.2026 gilt das Newsletter-Gate (assets/newsletter-gate.js): kein
   Overlay auf Warenkorb, Password-Page und Rechtsseiten, nicht in den 30 Min
   nach einem anderen Popup, und nicht, solange Cookie-Banner,
   Warenkorb-Drawer oder ein anderes Fenster offen ist (dann zählt die nächste
   Geste). Angemeldete (Flag tos_exit_captured, gesetzt von jedem Theme-Signup
   und von Klaviyo-Mail-Links), von Klaviyo erkannte (isIdentified) und
   eingeloggte Kundinnen sehen seit 7.10.2026 NUR die Warenkorb-Erinnerung
   (data-mode="cart"), nie das Newsletter-Formular; ohne Artikel nichts.
   Die T-MEMBERS-Variante für Bekannte ist stillgelegt (Markup und Texte
   bleiben in der Section).
   Im Theme-Editor: öffnet nur über shopify:section:select (zeigt beide Varianten). */
(function () {
  if (window.TOSExitIntent) return;
  window.TOSExitIntent = true;

  var LS_SHOWN = 'tos_exit_last_shown';
  var LS_DONE = 'tos_exit_captured';
  var SS_SESSION = 'tos_popup_shown_session';
  var SS_PV = 'tos_pv_count';
  var MIN_SECONDS_ON_PAGE = 8;
  var MIN_SCROLL_DEPTH = 0.5;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('.tos-exit[data-exit-intent]');
    if (!root) return;

    var mode = root.getAttribute('data-mode') || 'capture';
    var capDays = parseInt(root.getAttribute('data-cap-days'), 10) || 14;
    var desktopOn = root.getAttribute('data-desktop') !== 'false';
    var mobileOn = root.getAttribute('data-mobile') !== 'false';
    var isDesignMode = root.getAttribute('data-design-mode') === 'true';
    var requireEngagement = root.getAttribute('data-require-engagement') !== 'false';
    var isCoarsePointer = window.matchMedia('(pointer: coarse)').matches;
    var loadedAt = Date.now();
    var opened = false;
    var routing = false;
    var lastFocus = null;

    function storageGet(key) {
      try { return window.localStorage.getItem(key); } catch (e) { return null; }
    }
    function storageSet(key, val) {
      try { window.localStorage.setItem(key, val); } catch (e) {}
    }
    function sessionGet(key) {
      try { return window.sessionStorage.getItem(key); } catch (e) { return null; }
    }
    function sessionSet(key, val) {
      try { window.sessionStorage.setItem(key, val); } catch (e) {}
    }

    // --- Interesse-Gate (identische Logik in assets/timed-popup.js) ----------
    // Kalte Besucher aus Ads sollen auf ihrer LANDING-Page kein Overlay sehen.
    // Ein Popup darf erst aufgehen, wenn echtes Interesse da ist: entweder ist
    // es nicht mehr die erste Seite dieses Besuchs, oder auf DIESER Seite wurde
    // mindestens die Haelfte gescrollt. Ohne dieses Gate unterbricht das
    // Overlay den Besucher, bevor er ueberhaupt ein Produkt gesehen hat.
    function pageviewCount() {
      // Bewusst ueber window gemerkt: exit-intent.js und timed-popup.js laufen
      // beide auf derselben Seite, der Zaehler darf nur EINMAL hochgehen.
      if (!window.__tosPageviews) {
        var n = parseInt(sessionGet(SS_PV) || '0', 10) + 1;
        sessionSet(SS_PV, String(n));
        window.__tosPageviews = n;
      }
      return window.__tosPageviews;
    }
    var pageviews = pageviewCount();
    var pageDepth = 0;
    function trackDepth() {
      var total = document.documentElement.scrollHeight - window.innerHeight;
      if (total > 0) pageDepth = Math.max(pageDepth, window.scrollY / total);
    }
    window.addEventListener('scroll', trackDepth, { passive: true });
    trackDepth();

    function engaged() {
      if (!requireEngagement) return true;
      if (pageviews >= 2) return true;
      return pageDepth >= MIN_SCROLL_DEPTH;
    }

    function allowed() {
      if (opened) return false;
      if (!engaged()) return false;
      // Gemeinsamer Session-Guard mit assets/timed-popup.js: pro Besuch oeffnet
      // hoechstens EIN Popup.
      if (sessionGet(SS_SESSION) === '1') return false;
      var last = parseInt(storageGet(LS_SHOWN) || '0', 10);
      if (last && Date.now() - last < capDays * 864e5) return false;
      if ((Date.now() - loadedAt) / 1000 < MIN_SECONDS_ON_PAGE) return false;
      return true;
    }

    function open(variant, force) {
      if (!force && !allowed()) return;
      opened = true;
      var captureReset = root.querySelector('.tos-exit__capture');
      if (captureReset) captureReset.classList.remove('is-success-only');
      lastFocus = document.activeElement;
      root.setAttribute('data-variant', variant);
      var headingSel = variant === 'members' ? '.tos-exit__members .tos-exit__heading' : '.tos-exit__heading';
      var heading = root.querySelector(headingSel);
      if (heading && heading.id) root.setAttribute('aria-labelledby', heading.id);
      root.hidden = false;
      // Reflow, damit die Transition greift
      void root.offsetWidth;
      root.classList.add('is-open');
      if (!force) {
        storageSet(LS_SHOWN, String(Date.now()));
        sessionSet(SS_SESSION, '1');
      }
      if (variant === 'capture' && !isCoarsePointer) {
        var input = root.querySelector('input[name="email"]');
        if (input) input.focus();
      }
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      root.classList.remove('is-open');
      window.setTimeout(function () { root.hidden = true; }, 380);
      document.removeEventListener('keydown', onKeydown);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') close();
    }

    root.addEventListener('click', function (e) {
      if (e.target === root) close();
      if (e.target.closest('[data-exit-close]')) close();
    });

    // Klaviyo-Onsite-API: kennt Klaviyo diesen Browser als Profil?
    // Fallback bei Timeout/Fehler/fehlendem Objekt: false (dann normales Capture).
    function checkIdentified() {
      return new Promise(function (resolve) {
        var done = false;
        function settle(v) {
          if (done) return;
          done = true;
          window.clearTimeout(timer);
          resolve(!!v);
        }
        var timer = window.setTimeout(function () { settle(false); }, 1200);
        try {
          if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
            window.klaviyo.isIdentified().then(settle, function () { settle(false); });
          } else {
            settle(false);
          }
        } catch (e) {
          settle(false);
        }
      });
    }

    // Newsletter-Gate (assets/newsletter-gate.js). Fehlt das Skript, gilt das
    // Verhalten ohne Gate (nur Flag, Cap und Session-Guard).
    function gate() { return window.TOSNewsletterGate || null; }
    function blocked() { var g = gate(); return g ? g.blockedReason(root) : ''; }
    function busy() { var g = gate(); return g ? g.busyReason(root) : ''; }

    // Eingeloggt (data-nl-customer) oder angemeldet (Flag)?
    function known() {
      var g = gate();
      return storageGet(LS_DONE) === '1' || !!(g && g.knownReason(root));
    }

    function trigger() {
      if (opened || routing || !allowed()) return;
      // Ausgeschlossene Seite oder Popup in den letzten 30 Min: nie. Cookie-
      // Banner, Drawer/Modal offen oder Tippen: diesmal nicht, die naechste
      // Geste zaehlt. Der Cap bleibt in beiden Faellen unangetastet.
      var g = gate();
      if (g && g.blockedReason(root, { allowKnown: true })) return;
      if (busy()) return;
      // Warenkorb-Erinnerung: fuer Gaeste UND fuer Angemeldete, Eingeloggte
      // und von Klaviyo Erkannte (Kathrin, 7.10.2026).
      if (mode === 'cart') {
        open('cart', false);
        return;
      }
      // Newsletter-Formular nur fuer Gaeste ohne Anmeldung.
      if (known()) return;
      routing = true;
      checkIdentified().then(function (identified) {
        routing = false;
        // Klaviyo kennt sie: kein Overlay (bis 3.10.2026 mobil T-MEMBERS).
        if (identified) return;
        if (opened || !allowed() || storageGet(LS_DONE) === '1' || blocked() || busy()) return;
        open('capture', false);
      });
    }

    // --- Klaviyo-Submit (Muster der Signup-Card) ---
    var form = root.querySelector('form[data-exit-form]');
    if (form) {
      var companyId = form.getAttribute('data-company');
      var listId = form.getAttribute('data-list');
      var formId = form.getAttribute('data-form');
      var msg = root.querySelector('.tos-exit__msg');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var input = form.querySelector('input[name="email"]');
        var email = (input.value || '').trim();
        if (!email || !email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
          msg.textContent = msg.getAttribute('data-error');
          msg.className = 'tos-exit__msg is-error';
          return;
        }
        if (!companyId || !listId) {
          msg.textContent = msg.getAttribute('data-error');
          msg.className = 'tos-exit__msg is-error';
          return;
        }
        var btn = form.querySelector('button[type="submit"]');
        btn.disabled = true;

        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      locale: document.documentElement.lang || 'en',
                      properties: { $source: 'Exit Intent', locale: document.documentElement.lang || 'en', language: document.documentElement.lang || 'en' }
                    }
                  }
                },
                custom_source: formId ? ('klaviyo-form-' + formId) : 'Exit Intent'
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        })
          .then(function (res) {
            if (!(res.ok || res.status === 202)) throw new Error('subscribe failed');
            form.style.display = 'none';
            msg.textContent = msg.getAttribute('data-success');
            msg.className = 'tos-exit__msg is-success';
            var captureEl = msg.closest('.tos-exit__capture');
            if (captureEl) captureEl.classList.add('is-success-only');
            storageSet(LS_DONE, '1');
            window.setTimeout(close, 2600);
          })
          .catch(function () {
            msg.textContent = msg.getAttribute('data-error');
            msg.className = 'tos-exit__msg is-error';
          })
          .finally(function () { btn.disabled = false; });
      });
    }

    // --- Editor-Verhalten: nur auf Section-Auswahl öffnen (zeigt beide Varianten) ---
    if (isDesignMode) {
      document.addEventListener('shopify:section:select', function (e) {
        if (e.target && e.target.contains(root)) open('editor', true);
      });
      document.addEventListener('shopify:section:deselect', function (e) {
        if (e.target && e.target.contains(root)) close();
      });
      return;
    }

    // --- Bild vorwärmen (Split-Layout) ---
    // Bild und Logo sind loading="lazy" im hidden-Container und würden erst
    // beim Öffnen laden (sichtbares Nachladen). Darf das Overlay in diesem
    // Besuch überhaupt noch aufgehen, werden sie nach window load + 3 s auf
    // eager gestellt. Kein Einfluss auf den kritischen Ladepfad; Trigger, Cap
    // und Gates bleiben unverändert (es wird nur gelesen, nichts gesetzt).
    function canStillOpen() {
      if (opened) return false;
      if (sessionGet(SS_SESSION) === '1') return false;
      var last = parseInt(storageGet(LS_SHOWN) || '0', 10);
      if (last && Date.now() - last < capDays * 864e5) return false;
      if (isCoarsePointer ? !mobileOn : !desktopOn) return false;
      // Ausgeschlossene Seite: öffnet nie. Schon eingetragen oder eingeloggt:
      // nur noch im Warenkorb-Modus.
      var g = gate();
      if (g && g.blockedReason(root, { allowKnown: true })) return false;
      if (mode !== 'cart' && known()) return false;
      return true;
    }
    function prewarm() {
      if (!canStillOpen()) return;
      var imgs = root.querySelectorAll('.tos-exit__media img, img.tos-exit__logo');
      for (var i = 0; i < imgs.length; i++) imgs[i].loading = 'eager';
    }
    function schedulePrewarm() { window.setTimeout(prewarm, 3000); }
    if (document.readyState === 'complete') schedulePrewarm();
    else window.addEventListener('load', schedulePrewarm, { once: true });

    // --- Trigger Desktop: Maus verlässt Viewport nach oben ---
    if (desktopOn && !isCoarsePointer) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) trigger();
      });
    }

    // --- Trigger Mobil: schnelles Aufwärts-Scrollen nach >=50% Tiefe ---
    if (mobileOn && isCoarsePointer) {
      var maxDepth = 0;
      var lastY = window.scrollY;
      var lastT = Date.now();
      window.addEventListener(
        'scroll',
        function () {
          var doc = document.documentElement;
          var total = doc.scrollHeight - window.innerHeight;
          if (total > 0) maxDepth = Math.max(maxDepth, window.scrollY / total);
          var now = Date.now();
          var dy = lastY - window.scrollY; // positiv = nach oben
          var dt = now - lastT;
          if (maxDepth >= 0.5 && dy > 300 && dt < 600) trigger();
          lastY = window.scrollY;
          lastT = now;
        },
        { passive: true }
      );
    }
  });
})();
